import { Component, OnInit, OnDestroy, Input,Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';


import { SettingsRulesService } from '@app/services/settings/srules.service';

import { RuleListItem, AvailableRuleEventElement } from '@app/models/rules';


@Component({
    selector: 'settings-rules-rule-list',
    templateUrl: './rule-list.component.html',
    styleUrls: ['./rule-list.component.scss']
})
export class SettingsRulesRuleListComponent implements OnInit, OnDestroy {

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;

    @Output() selectRule = new EventEmitter<any>();
    public availableEvents: Array<AvailableRuleEventElement>;
    public rules: Array<RuleListItem>;
    public selectedRule: any = null;
	public showForm:boolean = false;
	public access:boolean = true;
    public status: number = 0;

    protected rulesSubscriptor: Subscription;
    protected availableEventsSubscriptor: Subscription;

	constructor(public srulesSrv: SettingsRulesService){}

	ngOnInit(){
        this.rulesSubscriptor = this.srulesSrv.selectRules().subscribe((rules: RuleListItem[]) => { 
            this.rules = rules;
            this.initView();
        });

        this.availableEventsSubscriptor = this.srulesSrv.selectAvailableEvents().subscribe((availables: AvailableRuleEventElement[] ) => {
            this.availableEvents = availables;
            this.initView();
        });
        // this.loadRules();
	}

    initView() : void {
        this.status = (this.rules?.length > 0 && this.availableEvents?.length > 0) ? this.STATUS_DONE : this.STATUS_LOADING;
    }

    ngOnDestroy() {
        this.rulesSubscriptor.unsubscribe();
        this.availableEventsSubscriptor.unsubscribe();
    }

    // Rules already loaded on the parent main component
    // protected loadRules(){
    //     this.srulesSrv.loadRules();
    // }

    // TODO imrpove
    getDescription(eventKey: string) {
        let event = this.availableEvents.filter((re: AvailableRuleEventElement) => re.key == eventKey)
        if(event.length>0)
            return event[0].description;
        
        return "Event deprecated!"
    }

    // protected getEvent(key: string){
    //     // todo: get event description by key
    //     let event = this.availableEvents.filter((event: any) => event.value == key)
    //     if(event.length>0)
    //         return event[0].title;
    //     // if note even defined/loaded return key only
    //     return key;
    // }


    onSelectRule(rule: any){
        if(!rule.active)
            return;

        this.selectedRule = rule;
        this.selectRule.emit(rule.id)
    }

    deactivate(rule: RuleListItem) {
        this.srulesSrv.deactiveRule(rule.id);
    }

    activate(rule: any) {
        this.srulesSrv.activeRule(rule.id);
    }


}
